// extracted by mini-css-extract-plugin
module.exports = {"select-dropdown":"Select_select-dropdown__XnBmo"};